import { initialState, ContractChangeRequestState } from "./state";
import { Actions } from './actions';
import {
    SET_REQUEST_LIST, SET_REQUEST_BY_ID, ADD_REQUEST_RESPONSE, UPDATE_REQUEST_RESPONSE,
    DELETE_REQUEST_RESPONSE, APPROVE_REJECT_REQUEST_RESPONSE, REQUEST_BY_FIELD_LIST
} from "./actionTypes";

export function ContractChangeRequestReducer(state = initialState, action: Actions): ContractChangeRequestState {
    switch (action.type) {
        case SET_REQUEST_LIST:
            return Object.assign({}, state, {
                requestList: action.payload
            });
        case REQUEST_BY_FIELD_LIST:
            return Object.assign({}, state, {
                requestByFieldList: action.payload
            });
        case SET_REQUEST_BY_ID:
            return Object.assign({}, state, {
                requestById: action.payload
            });
        case ADD_REQUEST_RESPONSE:
            return Object.assign({}, state, {
                addRequestResponse: action.payload
            });
        case UPDATE_REQUEST_RESPONSE:
            return Object.assign({}, state, {
                updateRequestResponse: action.payload
            });
        case DELETE_REQUEST_RESPONSE:
            return Object.assign({}, state, {
                deleteRequestResponse: action.payload
            });
        case APPROVE_REJECT_REQUEST_RESPONSE:
            return Object.assign({}, state, {
                approveRejectRequestResponse: action.payload
            });
        default:
            return state;
    }
}
